import { useEffect, useState } from 'react'
import { Typography, Table, Row, Col } from 'antd'
import { WhatsAppOutlined, PhoneOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { getAndSearchUsers } from '../actions/usersAction'
import { CustomInput } from '../components/ui/CustomInput'
import Colors from '../utils/colors'
import Constants from '../utils/constants'
import dayjs from 'dayjs'

const { Title } = Typography

const Users = () => {
  const dispatch = useDispatch()
  const { loading, users, totalUsers } = useSelector((state) => state.users)
  const { message: whatsAppMessage } = useSelector((state) => state.whatsAppMessage)

  const [currentPage, setCurrentPage] = useState(1)
  const [limit] = useState(Constants.ITEMS_PER_PAGE)
  const [filters, setFilters] = useState({ search: '' })

  useEffect(() => {
    dispatch(getAndSearchUsers({ page: currentPage, perPage: limit }))
  }, [dispatch])

  const columns = [
    {
      title: '#',
      key: 'index',
      render: (_, __, index) => (currentPage - 1) * limit + index + 1,
      width: 50
    },
    {
      title: 'Contact Number',
      dataIndex: 'contactNumber',
      key: 'contactNumber',
      sorter: true,
      width: 100
    },
    {
      title: 'Last Login',
      dataIndex: 'lastLogin',
      key: 'lastLogin',
      render: (lastLogin) => lastLogin ? dayjs(lastLogin).format('MMM DD, YYYY h:mm A') : 'Never',
      width: 120
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <div 
          onClick={() => handleWhatsAppClick(record.contactNumber)}
          style={{
            color: Colors.whatsapp,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingLeft: 10
          }}
        >
          <WhatsAppOutlined style={{ transform: 'scale(2)' }} />
        </div>
      ),
      width: 100
    }
  ]

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value }
    setFilters(newFilters)
    setCurrentPage(1)
    dispatch(getAndSearchUsers({ page: 1, perPage: limit, ...newFilters }))
  }

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current)
    dispatch(getAndSearchUsers({ page: pagination.current, perPage: limit, ...filters }))
  }

  const handleWhatsAppClick = (contactNumber) => {
    const message = encodeURIComponent(whatsAppMessage || '')
    const whatsappUrl = `https://web.whatsapp.com/send?phone=${contactNumber}&text=${message}`
    window.open(whatsappUrl, '_blank')
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <Title level={4} style={{ color: Colors.primary, margin: 0 }}>
          All Users
        </Title>
      </div>

      <Row gutter={16}>
        <Col xs={24} sm={12} md={8} lg={5} style={{ marginBottom: 16 }}>
          <CustomInput
            placeholder="Filter by contact number"
            prefix={<PhoneOutlined style={{ color: Colors.gray }} />}
            value={filters.search}
            onChange={(e) => handleFilterChange('search', e.target.value)}
          />
        </Col>
      </Row>
      
      <div style={{ width: '100%', overflowX: 'auto', border: `1px solid ${Colors.darkerGray}`, borderRadius: 10 }}>
        <Table
          columns={columns}
          dataSource={users || []}
          loading={loading}
          rowKey={(record) => record._id || record.contactNumber}
          pagination={{
            current: currentPage,
            total: totalUsers || 0,
            pageSize: limit,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users`,
            itemRender: (current, type, originalElement) => {
              if (type === 'page') {
                return (
                  <span style={{
                    backgroundColor: current === currentPage ? Colors.primary : 'transparent',
                    color: current === currentPage ? Colors.white : Colors.primary,
                    border: `1px solid ${Colors.primary}`,
                    padding: '4px 8px',
                    borderRadius: 4,
                    cursor: 'pointer'
                  }}>
                    {current}
                  </span>
                )
              }
              return originalElement
            }
          }}
          onChange={handleTableChange}
          scroll={{ x: 800 }}
          size="middle"
        />
      </div>
    </div>
  )
}

export default Users